export default __webpack_public_path__ + "49a9ba2905527992df32858fe9aa4ba67239dc691839f4e76676dbb7e9fb1273.png";